import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { CustomAccordion, Title } from "../styles/CommonQuestionsStyles";
import { ProductTable } from "./ProductTable";
import type { AccordionChangeHandler } from "./commonQuestionsTypes";

const PRODUCT_REQUIREMENT_PANEL_ID = "panel_requirement";

const PRODUCT_REQUIREMENT_QUESTION =
  "Qual o período de carência dos planos SulAmérica Odonto?";

type ProductRequirementProps = {
  expanded: string | false;
  handleChange: AccordionChangeHandler;
};

export const ProductRequirement = ({
  expanded,
  handleChange,
}: ProductRequirementProps) => {
  const isExpanded = expanded === PRODUCT_REQUIREMENT_PANEL_ID;

  return (
    <CustomAccordion
      expanded={isExpanded}
      onChange={handleChange(
        PRODUCT_REQUIREMENT_PANEL_ID,
        PRODUCT_REQUIREMENT_QUESTION
      )}
    >
      <AccordionSummary
        expandIcon={isExpanded ? <RemoveIcon /> : <AddIcon />}
        aria-controls="panel_requirementbh-content"
        id="panel_requirementbh-header"
      >
        <Title variant="h6" $isexpanded={isExpanded}>
          {PRODUCT_REQUIREMENT_QUESTION}
        </Title>
      </AccordionSummary>

      <AccordionDetails
        id="panel_requirementbh-content"
        aria-labelledby="panel_requirementbh-header"
      >
        <ProductTable />
      </AccordionDetails>
    </CustomAccordion>
  );
};
